import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

import {
  readTechSupportMode,
  subscribeTechSupportMode,
  toggleTechSupportMode,
  writeTechSupportMode,
} from '@app/providers/TechSupportMode/techSupportMode.storage';

type TechSupportModeContextValue = {
  enabled: boolean;
  setEnabled: (next: boolean) => void;
  toggle: () => void;
};

export const TechSupportModeContext =
  createContext<TechSupportModeContextValue | null>(null);

export const TechSupportModeProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [enabled, setEnabledState] = useState<boolean>(() =>
    readTechSupportMode()
  );

  useEffect(() => subscribeTechSupportMode(setEnabledState), []);

  const setEnabled = useCallback((next: boolean) => {
    writeTechSupportMode(next);
    setEnabledState(next);
  }, []);

  const toggle = useCallback(() => {
    const next = toggleTechSupportMode();
    setEnabledState(next);
  }, []);

  const value = useMemo(
    () => ({ enabled, setEnabled, toggle }),
    [enabled, setEnabled, toggle]
  );

  return (
    <TechSupportModeContext.Provider value={value}>
      {children}
    </TechSupportModeContext.Provider>
  );
};
